import { z } from "zod";

/**
 * Gestao de usuarios do painel (membership no tenant ativo).
 */

export const slugDePapelSchema = z.enum([
  "admin",
  "creator",
  "designer",
  "editor",
  "client",
]);

export const papelSchema = z.object({
  id: z.string().uuid(),
  slug: slugDePapelSchema,
  nome: z.string().min(1),
});

export const usuarioDoPainelSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  nome: z.string().min(1),
  ativo: z.boolean(),
  papel: papelSchema,
  criadoEm: z.string().datetime(),
});

export const listaDeUsuariosSchema = z.object({
  itens: z.array(usuarioDoPainelSchema),
});

export const listaDePapeisSchema = z.object({
  itens: z.array(papelSchema),
});

export const criarUsuarioSchema = z.object({
  email: z.string().trim().email().max(320),
  nome: z.string().trim().min(2).max(200),
  senha: z.string().min(8).max(200),
  papelSlug: slugDePapelSchema,
});

export const atualizarUsuarioSchema = z
  .object({
    nome: z.string().trim().min(2).max(200).optional(),
    papelSlug: slugDePapelSchema.optional(),
    senha: z.string().min(8).max(200).optional(),
  })
  .refine(
    (valor) =>
      valor.nome !== undefined ||
      valor.papelSlug !== undefined ||
      valor.senha !== undefined,
    { message: "Informe ao menos um campo para atualizar" },
  );

export const atualizarStatusUsuarioSchema = z.object({
  ativo: z.boolean(),
});

export type SlugDePapelContrato = z.infer<typeof slugDePapelSchema>;
export type PapelContrato = z.infer<typeof papelSchema>;
export type UsuarioDoPainel = z.infer<typeof usuarioDoPainelSchema>;
export type ListaDeUsuarios = z.infer<typeof listaDeUsuariosSchema>;
export type ListaDePapeis = z.infer<typeof listaDePapeisSchema>;
export type CriarUsuario = z.infer<typeof criarUsuarioSchema>;
export type AtualizarUsuario = z.infer<typeof atualizarUsuarioSchema>;
export type AtualizarStatusUsuario = z.infer<typeof atualizarStatusUsuarioSchema>;
